import AntTooltip from 'antd-core/es/tooltip';
import styled, { css } from 'styled-components';
import { withInjectedClassName } from '@10d/tend-ui-factories';

const Root = styled(withInjectedClassName(AntTooltip, 'overlayClassName')) `
  &.tend-ui-tooltip {
    .tend-ui-tooltip-arrow::before {
      clip-path: polygon(
        1.6568542494923806px 100%,
        50% 1.6568542494923806px,
        14.34314575050762px 100%,
        1.6568542494923806px 100%
      );
    }

    .tend-ui-tooltip-inner {
      padding: 8px;
      ${props => props.$lineBreak &&
    css `
          white-space: pre-line;
        `}
    }
  }
`;

export { Root };
